export default __webpack_public_path__ + "static/media/127.e2360345.png";